export default "__VITE_ASSET__Du2PyD3J__"